module.exports = __webpack_public_path__ + "552ab29dd4f91097111206d9f3452130.svg";